import { Directive, HostListener, Input } from '@angular/core';
import { MultiFileUploader } from './multifile-uploader';

@Directive({
    selector: '[multidropFile]',
    standalone: true
})
export class MultiDropFileDirective {

    @Input() host: MultiFileUploader; // Referencia del componente host que esta usando la directiva

    constructor(
    ) {
    }

    @HostListener('drop', ['$event']) onDrop(e: DragEvent): void {
        e.preventDefault();
        e.stopPropagation();
        this.setDragOverCounter(0);
        for(let i = 0; i < e.dataTransfer.files.length; i++) {
            this.host.uploadFile(e.dataTransfer.files.item(i));
        }
    }

    @HostListener('dragover', ['$event']) onDragOver(e: DragEvent): void {
        e.preventDefault();
        e.stopPropagation();
    }

    @HostListener('dragenter', ['$event']) onDragEnter(e: DragEvent): void {
        this.setDragOverCounter(this.host.dragOverCounter + 1);
    }

    @HostListener('dragleave', ['$event']) onDragLeave(e: DragEvent): void {
        this.setDragOverCounter(this.host.dragOverCounter - 1);
    }

    setDragOverCounter(value: number) {
        this.host.dragOverCounter = value;
        this.host.isDragOver = (this.host.dragOverCounter > 0);
    }
}
